import { Dialog, DialogContent } from '@/shared/ui/dialog';

import { ClinicalVisitPanel } from './ClinicalVisitPanel';

export function ClinicalVisitModal({
  sale_order_id,
  open,
  onOpenChange,
}: {
  sale_order_id: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
        <ClinicalVisitPanel sale_order_id={sale_order_id} />
      </DialogContent>
    </Dialog>
  );
}
